var React = require('react');

function SCrossMedium18N (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.77,11.69907,10.06055,8.98965,12.77,6.28023a.74994.74994,0,0,0-1.06058-1.06058L9,7.9291,6.29058,5.21965A.74994.74994,0,0,0,5.23,6.28023L7.93945,8.98965,5.23,11.69907a.74994.74994,0,0,0,1.06058,1.06058h0L9,10.0502l2.70942,2.70945A.74994.74994,0,0,0,12.77,11.69907Z","fill":"var(--iconFill, #464646)"}));
}

SCrossMedium18N.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = SCrossMedium18N;

SCrossMedium18N.default = SCrossMedium18N;
